import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class StochasticSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForD = this.yAccessorForD.bind(this);
    this.yAccessorForK = this.yAccessorForK.bind(this);
  }
  yAccessorForD(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).D;
  }
  yAccessorForK(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).K;
  }
  render() {
    const { className, stroke, refLineOpacity, onContextMenu } = this.props;
    const { overSold, middle, overBought } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForD}
          stroke={
            typeof stroke.dLine === "string"
              ? { color: stroke.dLine }
              : stroke.dLine
          }
          fill="none"
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForK}
          stroke={
            typeof stroke.kLine === "string"
              ? { color: stroke.kLine }
              : stroke.kLine
          }
          fill="none"
          onContextMenu={onContextMenu}
        />
        <StraightLine
          stroke={{
            ...(typeof stroke.top === "string"
              ? { color: stroke.top }
              : stroke.top),
            opacity: refLineOpacity,
          }}
          yValue={overBought}
          onContextMenu={onContextMenu}
        />
        <StraightLine
          stroke={{
            ...(typeof stroke.middle === "string"
              ? { color: stroke.middle }
              : stroke.middle),
            opacity: refLineOpacity,
          }}
          yValue={middle}
          onContextMenu={onContextMenu}
        />
        <StraightLine
          stroke={{
            ...(typeof stroke.bottom === "string"
              ? { color: stroke.bottom }
              : stroke.bottom),
            opacity: refLineOpacity,
          }}
          yValue={overSold}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

StochasticSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.shape({
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    middle: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      .isRequired,
    bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      .isRequired,
    dLine: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    kLine: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  }).isRequired,
  overSold: PropTypes.number.isRequired,
  middle: PropTypes.number.isRequired,
  overBought: PropTypes.number.isRequired,
  refLineOpacity: PropTypes.number.isRequired,
  onContextMenu: PropTypes.func,
};

StochasticSeries.defaultProps = {
  className: "react-stockcharts-stochastic-series",
  stroke: {
    top: "#964B00",
    middle: "#000000",
    bottom: "#964B00",
    dLine: "#17becf",
    kLine: "#ff7f0e",
  },
  overSold: 20,
  middle: 50,
  overBought: 80,
  refLineOpacity: 0.3,
};

export default StochasticSeries;
